<a href="#content" class="offscreen">{{'ZurückZumInhalt'|translate}}</a>
<ngx-loading-bar color="#A8B30A" height="0.2rem" [includeSpinner]="false"></ngx-loading-bar>
<div *ngIf="deploymentMode === 'PUBLIC'">
  <cap-intercapi-public-dashboard></cap-intercapi-public-dashboard>
</div>
<div *ngIf="deploymentMode === 'READ'">
  <cap-intercapi-dashboard></cap-intercapi-dashboard>
</div>
<div *ngIf="deploymentMode === 'WRITE'">
  <h1>Intercapi writeable mode not yet implemented</h1>
</div>
